import { useEffect } from "react";
import { Guess, State } from "../../models/gameModels";
import useMethods from "../../utils/useMethods";
import GameBoard from "./GameBoard";
import { gameMethods } from "./gameMethods";

export interface GameConfig {
  showAdmin: boolean;
  showTimer: boolean;
}

export interface GameEvents {
  onGuess: (state: State, guess?: Guess) => void;
  onWin: (state: State) => void;
  onLose: (state: State) => void;
  onStateChange: (state: State) => void;
  onShowModal?: (state: State) => void;
}

export default function Game({
  events,
  initState,
  config,
}: {
  events: GameEvents;
  initState: State;
  config?: GameConfig;
}) {
  const stateWithTriggers = {
    ...initState,
    triggers: events,
  };
  const [state, fns] = useMethods(
    gameMethods,
    stateWithTriggers,
    () => stateWithTriggers,
  );
  useEffect(() => {
    fns.changeState(initState);
  }, [initState, fns]);
  useEffect(() => {
    events.onStateChange(state);
  }, [state, events]);
  useEffect(() => {
    if (state.result !== undefined) {
      events.onShowModal?.(state);
    }
  }, []);
  return (
    <GameBoard config={config} state={state} fns={fns} triggers={events} />
  );
}
